export default __webpack_public_path__ + "static/media/logo-sm-dark.589edf02.png";